export default "__VITE_ASSET__626597b6__"